import ancientDebris from "./images/Ancient_Debris_JE1_BE1.png"
import diamondBlock from "./images/Block_of_Diamond_JE5_BE3.png"
import goldBlock from "./images/Block_of_Gold_JE6_BE3.png"
import ironBlock from "./images/Block_of_Iron_JE4_BE3.png"
import netheriteBlock from "./images/Block_of_Netherite_JE1_BE1.png"
import cobblestone from "./images/Cobblestone.png"
import diamondOre from "./images/Diamond_Ore_JE5_BE5.png"
import goldOre from "./images/Gold_Ore_JE7_BE4.png"
import grassBlock from "./images/Grass_Block.png"
import ironOre from "./images/Iron_Ore_JE6_BE4.png"
import oakLog from "./images/Oak_Log_29_JE5_BE3.png"
import oakPlanks from "./images/Oak_Planks.png"
import stoneBricks from "./images/Stone_Bricks_JE3_BE2.png"
import stone from "./images/Stone.png"
export const products = [
    {name: "Ancient Debris", image: ancientDebris, price: 50.00},
    {name: "Block of Diamond", image: diamondBlock, price: 499.99},
    {name: "Block of Gold", image: goldBlock, price: 299.99},
    {name: "Block of Iron", image: ironBlock, price: 100},
    {name: "Block of netherite", image: netheriteBlock, price: 1750.90},
    {name: "Cobblestone", image: cobblestone, price: 10},
    {name: "Diamond Ore", image: diamondOre, price: 75.85},
    {name: "Gold Ore", image: goldOre, price: 60.98},
    {name: "Grass Block", image: grassBlock, price: 1.00},
    {name: "Iron Ore", image: ironOre, price: 15},
    {name: "Oak Log", image: oakLog, price: 4.69},
    {name: "Oak Planks", image: oakPlanks, price: 7},
    {name: "Stone Bricks", image: stoneBricks, price: 9.99},
    {name: "Stone", image: stone, price:1.99},
]